
  <a style="cursor:pointer" *ngIf="showButton" (click)="buttonClick()">{{ (showSidebar) ? "Hide" : "Show" }} Menu</a>
  <ng-container>
    <div id="wrapper">
      <div class="row no-gutters">
        <div id="aims-sidebar" (mouseenter)="hoverOn()"
             (mouseleave)="hoverOff()"
             [ngClass]="'col-sm-2'"
             [ngStyle]="(iconsOnly | async) ? {'width':'2%'} : ''"
             role="navigation"
             *ngIf="showSidebar && calcIf()">
          <div class="sidebar-nav">
            <ul class="nav"> 
              <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
            </ul>
          </div>
        </div>
        <div id="page-wrapper" [ngClass]="(showSidebar && calcIf()) ? 'col-sm-10' : 'col-xs-12'" [ngStyle]="(iconHoverMode && iconsOnly|async) ? {'padding-right':'20px', 'width':'98%'} : {'padding-right':'20px'}">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </ng-container>
